import { useTranslation } from 'react-i18next';
import { Form, Input, Row, Col } from 'antd';
import { IPOButton, IPOMessage } from '@hylaa-npm/ipod';

import { IShowType } from '../Login';
import { restPassword } from '@/apis/login';
import backIcon from '@/images/system/password-back.svg';
import { IForgetPassword } from '@/container/User';
import { FormCSS } from '../Login/style';
import { ResetForm } from './style';

function ResetPassword({
	body,
	pageChange,
	isToLogin = true,
	handleCancel,
	handleBack,
}: ILogInProps & IForgetPassword) {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const regPassword: () => void = async () => {
		if (!form.getFieldValue('password')) {
			IPOMessage.error(t('system.plInputPassword'));
			return;
		}
		if (form.getFieldValue('password') !== form.getFieldValue('newPassword')) {
			IPOMessage.error(t('common.passwordInequality'));
			return;
		}
		if (!body?.code) {
			return;
		}
		restPassword({
			newPass: form.getFieldValue('password'),
			code: body.code,
			mobile: body.mobile,
			areaCode: body.areaCode,
		})
			.then((body) => {
				IPOMessage.success(t('common.passwordResetSuccee'));
				pageChange(IShowType.LOGIN);
			})
			.catch((e) => {});
	};
	return (
		<FormCSS>
			<div className="form-title">
				<img
					src={backIcon}
					alt=""
					className="form-back-icon"
					onClick={() => handleBack && handleBack()}
				/>{' '}
				{t('system.reset') + t('system.password')}
			</div>
			<ResetForm>
				<Form form={form} colon={false} labelCol={{ span: 5, offset: 0 }}>
					<Form.Item label={t('system.password')} name="password">
						<Input.Password placeholder={t('system.input') + t('system.password')} />
					</Form.Item>
					<Form.Item label={t('system.confirmPassword')} name="newPassword">
						<Input.Password placeholder={t('system.input') + t('system.password')} />
					</Form.Item>
					<Row className="form-btns">
						<Col span={5}></Col>
						<Col span={19}>
							<IPOButton type="primary" htmlType="submit" onClick={() => regPassword()}>
								{t('common.confirm')}
							</IPOButton>
							{isToLogin ? (
								<IPOButton type="link" onClick={() => pageChange(IShowType.LOGIN)}>
									{t('system.goLogin')}
								</IPOButton>
							) : (
								<IPOButton type="link" onClick={() => handleCancel && handleCancel()}>
									取消
								</IPOButton>
							)}
						</Col>
					</Row>
				</Form>
			</ResetForm>
		</FormCSS>
	);
}

export default ResetPassword;
